<template lang="pug">
  .field-reservation-id(v-if="$is('reservation-id')")
    .field-value
      router-link(:to="{name:'reservation', params:{id:item.id}}")
        h3.reservation-number.pm-text-highlight R{{item.number}}

  .field-vehicle-info.text-center(v-else-if="$is('vehicle-info')")

    img.vehicle-picture(:src="item.vehicle.picture_external")
    .field-value {{item.vehicle.brand}} {{item.vehicle.model}}
    //vehicle-fields(:fieldName="'vehicle-brand'", :item="item.vehicle")
    vehicle-fields(:fieldName="'vehicle-plate'", :item="item.vehicle")
  .field-vehicle-info.text-center(v-else-if="$is('vehicle-info-no-img')")
    .field-value {{item.vehicle.brand}} {{item.vehicle.model}}
    //vehicle-fields(:fieldName="'vehicle-brand'", :item="item.vehicle")
    vehicle-fields(:fieldName="'vehicle-plate'", :item="item.vehicle")

  .field-reservation-start(v-else-if="$is('reservation-start')")
    .field-value {{$dateFormat(item.start,'DD MMM YYYY HH:mm')}}
    .field-value {{$dateFormat(item.end,"DD MMM YYYY HH:mm")}}
    .field-value {{$dateDifference(item.start, item.end)}}

  .field-reservation-start(v-else-if="$is('reservation-start-end')")
    .field-value {{$dateFormat(item.start,'DD MMM HH:mm')}}
    .field-value {{$dateFormat(item.end,"DD MMM HH:mm")}}
  //.field-reservation-end(v-else-if="$is('reservation-end')")
    .field-value {{$dateFormat(item.end,"HH:mm")}}

  .field-reservation-bmode(v-else-if="$is('reservation-bmode')")
    .field-value {{item.booking_mode}}
  .field-reservation-distance(v-else-if="$is('reservation-distance')")

    .field-value
      span.fa.fa-tachometer
      span &nbsp; {{Math.round(item.distance)}}{{configuration.locale.locale_distance_unit.value}}
  .field-reservation-hours(v-else-if="$is('reservation-hours')")
    .field-value {{$dateDifference(item.start, item.end)}}
  .field-reservation-cost(v-else-if="$is('reservation-cost')")
    .field-value
      span.fa.fa-money
      span &nbsp; {{item.cost === null ? '--' : currency + item.cost}}
  .field-reservation-status(v-else-if="$is('reservation-status')")
    .field-value {{item.status}}
    .field-value Billing: {{item.billing_status}}
    .field-value(v-if="item.billing_status==='UNCHARGEABLE'") Cancelled: {{item.canceled}}
</template>
<script type="text/babel">
  import Status from '../Status.vue'
  import VehicleFields from './VehicleFields.vue'
  import {mapState} from 'vuex'

  export default {
    name: "ReservationFields",
    components: {
      VehicleFields,
      Status
    },
    data() {
      return {}
    },
    created() {
    },
    methods: {},
    computed: {
      type() {
        return this.fieldName
      },
      ...mapState({
        configuration: state => state.configuration,
      }),
      currency() {
        return this.configuration.commercial.commercial_currency.value
      },
    },
    props: {
      item: Object,
      fieldName: {
        type: String,
        default: ''
      }
    },
  }
</script>
<style lang="sass" rel="stylesheet/sass">
.field-reservation-id
  h3
    margin-bottom: 0
</style>



// WEBPACK FOOTER //
// ReservationFields.vue?2a1b17e4